(function () {
  var form = document.querySelector('footer form[action^="/contact"]');
  if (!form || form.dataset.klaviyoConnected) return;
  form.dataset.klaviyoConnected = 'true';
  var busy = false;

  function hasProtectedSubmit() {
    return typeof form.submit === 'function' && form.submit !== HTMLFormElement.prototype.submit;
  }

  function captchaReady() {
    return new Promise(function (resolve, reject) {
      var settled = false, poll;
      var deadline = setTimeout(function () { finish(new Error('captcha_timeout')); }, 15000);
      function finish(error) {
        if (settled) return;
        settled = true;
        clearTimeout(deadline);
        clearTimeout(poll);
        error ? reject(error) : resolve();
      }
      function connect() {
        if (settled) return;
        if (!window.Shopify || !window.Shopify.captcha || typeof window.Shopify.captcha.protect !== 'function') {
          poll = setTimeout(connect, 50);
          return;
        }
        try {
          window.Shopify.captcha.protect(form, function () {
            if (!settled) finish(hasProtectedSubmit() ? null : new Error('captcha_not_ready'));
          });
        } catch (error) { finish(error); }
      }
      connect();
    });
  }

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || !form.reportValidity()) return;
    var field = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-newsletter-result]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.newsletterResult = '';
      status.setAttribute('role', 'status');
      form.appendChild(status);
    }
    var wasReadOnly = field.readOnly, notice;
    busy = true;
    button.disabled = true;
    field.readOnly = true;
    field.value = field.value.trim();
    status.textContent = 'Inscription en cours\u2026';
    try {
      await captchaReady();
      if (!hasProtectedSubmit()) throw new Error('captcha_not_ready');
      status.textContent = 'Finalisation s\u00e9curis\u00e9e de votre inscription\u2026';
      notice = setTimeout(function () {
        status.textContent = 'La validation de s\u00e9curit\u00e9 prend du temps. Patientez ou rechargez la page avant de r\u00e9essayer.';
      }, 20000);
      await form.submit();
    } catch (error) {
      clearTimeout(notice);
      status.textContent = 'L\u2019inscription n\u2019a pas abouti. R\u00e9essayez dans un instant.';
      busy = false;
      button.disabled = false;
      field.readOnly = wasReadOnly;
    }
  }, true);
})();
